import { createContext, useContext, useMemo } from 'react'
import { useAtlasStocks } from './useAtlasStocks'
import { useLivePrices } from './useLivePrices'

const Ctx = createContext({ prices: {}, loading: true })

// Mount once in AppLayout — all panels share one price fetch for the full universe
export function UniversePriceProvider({ children }) {
  const { stocks } = useAtlasStocks()
  const tickers = useMemo(() => stocks.map((s) => s.ticker), [stocks])
  const { prices, loading } = useLivePrices(tickers)
  const value = useMemo(() => ({ prices, loading }), [prices, loading])
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useUniversePrices() {
  return useContext(Ctx)
}
